import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Avatar, Box, Menu, MenuItem } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { useNavigate } from 'react-router-dom';
import Logo from '../logoParallaxDev.png';

interface HeaderProps {
    onToggleSidebar: () => void; // Função para expandir/recolher a sidebar
    user: {
        nome: string;
        perfil: string;
    };
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, user }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate();

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.removeItem('token'); // Remove o token do localStorage
        localStorage.removeItem('user'); // Remove os dados do usuário, se armazenados
        navigate('/'); // Redireciona para a página de login
    };

    const getUserInitials = (nome: string) => {
        if (!nome) return '';
        const initials = nome
            .split(' ')
            .filter(Boolean)
            .map((n) => n[0])
            .join('');
        return initials.toUpperCase();
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: '#88A9C3' }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* Botão para expandir/recolher a sidebar */}
                <IconButton edge="start" color="inherit" onClick={onToggleSidebar}>
                    <MenuOpenIcon
                        fontSize='large'
                        sx={{ color: 'black' }} />
                </IconButton>

                {/* Logo da empresa */}
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
                    <img src={Logo} alt="Logo da Empresa" style={{ height: '15dvh', marginLeft: '10px' }} />
                </Typography>

                {/* Avatar e informações do usuário */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                        sx={{ width: 56, height: 56, color: '#000000', cursor: 'pointer' }}
                        onClick={handleMenuOpen}
                    >
                        {getUserInitials(user.nome)}
                    </Avatar>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem disabled>{user.nome}</MenuItem>
                        <MenuItem disabled>{user.perfil}</MenuItem>
                        <MenuItem onClick={handleLogout}>Sair</MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;